import React from "react";
import { CircularProgress, Typography, Box } from "@mui/material";

class SemiCircleProgress extends React.Component {
  render() {
    const {
      value,
      delta,
      size,
      label,
      maxValue = 5,
      minValue = 0,
    } = this.props;

    const numericValue = Number(value) || 0;
    const range = maxValue - minValue;
    const normalizedValue =
      range > 0 ? ((numericValue - minValue) / range) * 100 : 0;
    const progressColor = numericValue >= 0 ? "#4CAF50" : "#d32f2f";
    const displayValue =
      value === "" || value == null ? "-" : numericValue;

    return (
      <Box textAlign="center" style={{ margin: "10px" }}>
        <Typography variant="h6" component="div" color="textPrimary">
          {label}
        </Typography>
        <Box
          position="relative"
          display="inline-flex"
          alignItems="center"
          justifyContent="center"
        >
          <CircularProgress
            variant="determinate"
            value={100}
            size={size}
            thickness={4}
            style={{ color: "#e6ffe7" }}
          />
          <CircularProgress
            variant="determinate"
            value={Math.min(Math.max(normalizedValue, 0), 100)}
            size={size}
            thickness={5}
            style={{
              color: progressColor,
              position: "absolute",
              top: 0,
            }}
          />
          <Box
            top={0}
            left={0}
            bottom={0}
            right={0}
            position="absolute"
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <Typography
              variant="h4"
              component="div"
              color="textPrimary"
              style={{ fontSize: 18, fontWeight: "bold" }}
            >
              {displayValue}
            </Typography>
            {delta !== "" && delta != null && (
              <Typography
                variant="subtitle1"
                component="div"
                style={{
                  fontSize: 12,
                  color: Number(delta) >= 0 ? "green" : "red",
                }}
              >
                {Number(delta) > 0 ? `+${delta}` : delta}
              </Typography>
            )}
          </Box>
        </Box>
      </Box>
    );
  }
}

export default SemiCircleProgress;
